"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var Overview = function Overview(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 0h36a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5 7v26h26V7H7zm51-7h36a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H58a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5 7v26h26V7H63zM2 56h36a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V58a2 2 0 0 1 2-2zm5 7v26h26V63H7zm51-7h36a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H58a2 2 0 0 1-2-2V58a2 2 0 0 1 2-2zm5 7v26h26V63H63z",
    fill: "currentColor"
  })));
};
var _default = exports.default = Overview;